import { useRef } from "react";
import { toPng } from "html-to-image";
import { TournamentResponse } from "../../../../api/tournament";
import { TournamentType } from "../../../tournament/hook/useEditTournament";
import {
  StructureImageBody,
  StructureImageLeftBody,
  StructureImageHeader,
  StructureImageWrapper,
  StructureImageRightBody,
  StructureImageInformationWrapper,
  StructureImagePrizeWrapper,
  StructureCloseButton,
  StructureToImageButton,
  StructureButtonWrapper,
  StructureLeftBodyTitle,
  StructureImageInformationBox,
  StructureImageEarlyBirdBox,
  StructureImageInformationRow,
  StructureImageInformationItem,
  StructureImageEarlyBirdGridBox,
  StructureImageEarlyBirdItem,
  StructureImagePrizeRow,
  StructureImagePrizeBox,
  StructureImagePrizeHeader,
  StructureImagePrizeHeaderItem,
  StructureImagePrizeListWrapper,
  StructureImagePrizeListRow,
  StructureImageRightBodyHeader,
  StructureImageRightBodyHeaderItem,
  StructureImageRightBodyListWrapper,
  StructureImageRightBodyListRow,
} from "./style";
import {
  getTournamentTypeName,
  isEventType,
} from "../../../../utils/tournament-type";
import { Overlay } from "../../../../styles/popup";

interface StructureImageProps {
  data: TournamentResponse;
  onClose: () => void;
}

const StructureImage = ({ data, onClose }: StructureImageProps) => {
  const structureRef = useRef<HTMLDivElement>(null);

  const getPrizeType = () => {
    return data.tournamentType === TournamentType.Tournament ? "RB" : "%";
  };

  const toPngImage = async () => {
    if (!structureRef.current) return;

    try {
      // 요소의 실제 크기 계산
      const rect = structureRef.current.getBoundingClientRect();

      const dataUrl = await toPng(structureRef.current, {
        cacheBust: true,
        pixelRatio: 2,
        backgroundColor: "#ffffff",
        width: rect.width,
        height: rect.height,
        style: {
          transform: "none",
          position: "static",
          margin: "0",
          padding: "40px 30px",
          borderRadius: "13px",
          overflow: "hidden",
        },
        filter: (node) => {
          // 모든 노드의 border-radius 스타일을 강제 적용
          if (node.nodeType === 1) {
            const element = node as HTMLElement;
            if (element === structureRef.current) {
              element.style.borderRadius = "13px";
              element.style.overflow = "hidden";
            }
          }
          return true;
        },
      });

      const link = document.createElement("a");
      link.download = `${data.title}_structure.png`;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("이미지 생성 실패:", err);
      alert("이미지 생성에 실패했습니다.");
    }
  };
  return (
    <Overlay>
      <StructureImageWrapper ref={structureRef}>
        <StructureImageHeader>
          {data.title} ({data.subTitle}) {data.startDate}
        </StructureImageHeader>
        <StructureImageBody>
          <StructureImageLeftBody>
            <StructureImageInformationWrapper>
              <StructureLeftBodyTitle>INFORMATION</StructureLeftBodyTitle>
              <StructureImageInformationBox>
                <StructureImageInformationRow>
                  <StructureImageInformationItem>
                    <div className="title">바이인 금액</div>
                    <div className="value">{data.buyIn?.toLocaleString()}</div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">리엔트리 금액</div>
                    <div className="value">
                      {data.reBuyIn?.toLocaleString()}
                    </div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">애드온 금액</div>
                    <div className="value">{data.addOn?.toLocaleString()}</div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">레지마감</div>
                    <div className="value">
                      {data.registerDeadlineLevel} LV
                    </div>
                  </StructureImageInformationItem>
                </StructureImageInformationRow>
                <StructureImageInformationRow>
                  <StructureImageInformationItem>
                    <div className="title">바이인 칩</div>
                    <div className="value">
                      {data.buyInChip?.toLocaleString()}
                    </div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">리엔트리 칩</div>
                    <div className="value">
                      {data.reBuyInChip?.toLocaleString()}
                    </div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">애드온 칩</div>
                    <div className="value">
                      {data.adOnChip?.toLocaleString()}
                    </div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">토너먼트 형태</div>
                    <div className="value">
                      {getTournamentTypeName(data.tournamentType)}
                    </div>
                  </StructureImageInformationItem>
                </StructureImageInformationRow>
              </StructureImageInformationBox>
              {data.userLimit && (
                <StructureImageInformationBox>
                  <StructureImageInformationItem>
                    <div className="title">인원제한 얼리버드</div>
                    <div className="value">{data.userLimit}명</div>
                  </StructureImageInformationItem>
                  <StructureImageInformationItem>
                    <div className="title">얼리버드 칩</div>
                    <div className="value">
                      {data.earlyInChip?.toLocaleString()}
                    </div>
                  </StructureImageInformationItem>
                </StructureImageInformationBox>
              )}
              {data.levelLimitChip.length > 0 && (
                <StructureImageEarlyBirdBox>
                  <div className="title">레벨제한 얼리버드</div>
                  <StructureImageEarlyBirdGridBox>
                    {data.levelLimitChip.map((item) => (
                      <StructureImageEarlyBirdItem key={item.level}>
                        {item.level}LV {item.chip?.toLocaleString()}
                      </StructureImageEarlyBirdItem>
                    ))}
                  </StructureImageEarlyBirdGridBox>
                </StructureImageEarlyBirdBox>
              )}
            </StructureImageInformationWrapper>
            <StructureImagePrizeWrapper>
              <StructureLeftBodyTitle>PRIZE</StructureLeftBodyTitle>
              <StructureImagePrizeRow>
                <StructureImagePrizeBox>
                  <StructureImagePrizeHeader>
                    <StructureImagePrizeHeaderItem>
                      순위
                    </StructureImagePrizeHeaderItem>
                    {!isEventType(data.tournamentType) && (
                      <StructureImagePrizeHeaderItem>
                        프라이즈
                      </StructureImagePrizeHeaderItem>
                    )}
                    <StructureImagePrizeHeaderItem>
                      부상
                    </StructureImagePrizeHeaderItem>
                  </StructureImagePrizeHeader>
                  <StructureImagePrizeListWrapper>
                    {data.moneyInChip.slice(0, 10).map((item) => (
                      <StructureImagePrizeListRow key={item.rank}>
                        <div className="value">{item.rank}등</div>
                        {!isEventType(data.tournamentType) && (
                          <div className="value">
                            {item.point}
                            {getPrizeType()}
                          </div>
                        )}
                        <div className="value">{item.subPrize}</div>
                      </StructureImagePrizeListRow>
                    ))}
                  </StructureImagePrizeListWrapper>
                </StructureImagePrizeBox>
                {data.moneyInChip.length > 10 && (
                  <StructureImagePrizeBox>
                    <StructureImagePrizeHeader>
                      <StructureImagePrizeHeaderItem>
                        순위
                      </StructureImagePrizeHeaderItem>
                      <StructureImagePrizeHeaderItem>
                        프라이즈
                      </StructureImagePrizeHeaderItem>
                      <StructureImagePrizeHeaderItem>
                        부상
                      </StructureImagePrizeHeaderItem>
                    </StructureImagePrizeHeader>
                    <StructureImagePrizeListWrapper>
                      {data.moneyInChip.slice(10).map((item) => (
                        <StructureImagePrizeListRow key={item.rank}>
                          <div className="value">{item.rank}등</div>
                          <div className="value">
                            {item.point}
                            {getPrizeType()}
                          </div>
                          <div className="value">{item.subPrize}</div>
                        </StructureImagePrizeListRow>
                      ))}
                    </StructureImagePrizeListWrapper>
                  </StructureImagePrizeBox>
                )}
              </StructureImagePrizeRow>
            </StructureImagePrizeWrapper>
          </StructureImageLeftBody>
          <StructureImageRightBody>
            <StructureImageRightBodyHeader>
              <StructureImageRightBodyHeaderItem>
                LV
              </StructureImageRightBodyHeaderItem>
              <StructureImageRightBodyHeaderItem>
                SB
              </StructureImageRightBodyHeaderItem>
              <StructureImageRightBodyHeaderItem>
                BB
              </StructureImageRightBodyHeaderItem>
              <StructureImageRightBodyHeaderItem>
                ANTE
              </StructureImageRightBodyHeaderItem>
              <StructureImageRightBodyHeaderItem>
                TIME
              </StructureImageRightBodyHeaderItem>
            </StructureImageRightBodyHeader>
            <StructureImageRightBodyListWrapper>
              {data.structure.map((item) => (
                <>
                  {item.level === null ? (
                    <StructureImageRightBodyListRow key={item.level}>
                      <div className="value"></div>
                      <div className="value"></div>
                      <div className="break">BREAK</div>
                      <div className="value"></div>
                      <div className="value">{item.time?.toLocaleString()}</div>
                    </StructureImageRightBodyListRow>
                  ) : (
                    <StructureImageRightBodyListRow key={item.level}>
                      <div className="value">{item.level}</div>
                      <div className="value">
                        {item.smallBlind?.toLocaleString()}
                      </div>
                      <div className="value">
                        {item.bigBlind?.toLocaleString()}
                      </div>
                      <div className="value">{item.ante?.toLocaleString()}</div>
                      <div className="value">{item.time?.toLocaleString()}</div>
                    </StructureImageRightBodyListRow>
                  )}
                </>
              ))}
            </StructureImageRightBodyListWrapper>
          </StructureImageRightBody>
        </StructureImageBody>
      </StructureImageWrapper>
      <StructureButtonWrapper>
        <StructureCloseButton onClick={onClose}>창 닫기</StructureCloseButton>
        <StructureToImageButton onClick={toPngImage}>
          이미지로 저장
        </StructureToImageButton>
      </StructureButtonWrapper>
    </Overlay>
  );
};

export default StructureImage;
